import { render, staticRenderFns } from "./IdsListManage.vue?vue&type=template&id=4635915a&scoped=true&lang=pug"
import script from "./IdsListManage.vue?vue&type=script&lang=ts"
export * from "./IdsListManage.vue?vue&type=script&lang=ts"
import style0 from "./IdsListManage.vue?vue&type=style&index=0&id=4635915a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4635915a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VChip,VDivider,VIcon,VTextField})
